import * as React from 'react'

const SvgChevronSortDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 17.5l-4.375-4.375.875-.875 3.5 3.5 3.5-3.5.875.875L10 17.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgChevronSortDownIcon
